// How long a request has been waiting, as a small coloured age. Extracted from
// PurchasingQueuePage.js at Session 79.14c.
//
// THE THRESHOLDS ARE THE DECISION HERE — 3 days amber, 7 days red — and
// ConfirmationBadge deliberately reuses these same two numbers rather than
// inventing its own. See that file for why. Changing a number here changes both
// badges, which is intended.

import React from 'react';
import { ageDays } from '../../lib/purchasingQueue';

export default function AgeBadge({ ts }) {
  const days = ageDays(ts);
  const color = days >= 7 ? '#A32D2D' : days >= 3 ? '#9A5F00' : '#5C5C5C';
  return (
    <span style={{ fontSize: 10, color, fontWeight: days >= 3 ? 700 : 400 }}>
      {days === 0 ? 'Today' : `${days}d`}
    </span>
  );
}
